<template>
    <div class="flex items-center h-full">
        <vs-button @click="editData" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
    </div>
</template>

<script>
export default {
  name: 'EditActions',
  methods: {
    editData () {
      
      this.$router.push({ name:'lead-edit', params: { leadId: this.params.data.leads_id } })
    }
  }
}
</script>